"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import parse from "html-react-parser";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
interface TabItem {
  title: string;
  content: string;
  key: string;
}
interface ProductTabsProps {
  tabs: TabItem[];
}
const ProductTabs: React.FC<ProductTabsProps> = t0 => {
  const $ = _c(53);
  const {
    tabs
  } = t0;
  const [activeTab, setActiveTab] = useState(tabs[0]?.key);
  const [isModalOpen, setIsModalOpen] = useState(false);
  if (!tabs || tabs.length === 0) {
    return null;
  }
  let T0;
  let T1;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== activeTab || $[1] !== isModalOpen || $[2] !== tabs) {
    let t13;
    if ($[17] !== activeTab) {
      t13 = tab => tab.key === activeTab;
      $[17] = activeTab;
      $[18] = t13;
    } else {
      t13 = $[18];
    }
    const activeTabContent = tabs.find(t13);
    const formatContent = _temp;
    t12 = "w-full max-w-[1440px] mx-auto lg:px-12 px-3 mt-12 lg:mt-24 mb-16 font-outfit";
    t10 = "bg-white/80 backdrop-blur-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] rounded-2xl overflow-hidden border border-[#E5E5E5]/50";
    let t14;
    if ($[19] !== activeTab || $[20] !== tabs) {
      let t15;
      if ($[22] !== activeTab) {
        t15 = tab_0 => {
          const isActive = activeTab === tab_0.key;
          return <button key={tab_0.key} onClick={() => setActiveTab(tab_0.key)} className={`relative px-8 py-5 text-sm lg:text-base font-semibold uppercase tracking-wider transition-colors whitespace-nowrap outline-none ${isActive ? "text-[#037A6A]" : "text-[#5A5A5A] hover:text-[#303030]"}`}>{tab_0.title}{isActive && <motion.div layoutId="activeTabIndicator" className="absolute bottom-0 left-0 right-0 h-1 bg-[#037A6A] rounded-t-full" initial={false} transition={{
              type: "spring",
              stiffness: 500,
              damping: 30
            }} />}</button>;
        };
        $[22] = activeTab;
        $[23] = t15;
      } else {
        t15 = $[23];
      }
      t14 = tabs.map(t15);
      $[19] = activeTab;
      $[20] = tabs;
      $[21] = t14;
    } else {
      t14 = $[21];
    }
    if ($[24] !== t14) {
      t11 = <div className="flex border-b border-gray-100 bg-[#F9F8F6] overflow-x-auto no-scrollbar relative">{t14}</div>;
      $[24] = t14;
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    t9 = "p-8 lg:p-10 relative bg-gradient-to-br from-white to-[#F8FFFE] min-h-[200px]";
    T1 = AnimatePresence;
    t8 = "wait";
    T0 = motion.div;
    t1 = activeTab;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        opacity: 0,
        y: 10
      };
      t3 = {
        opacity: 1,
        y: 0
      };
      t4 = {
        opacity: 0,
        y: -10
      };
      t5 = {
        duration: 0.2,
        ease: "easeOut"
      };
      $[26] = t2;
      $[27] = t3;
      $[28] = t4;
      $[29] = t5;
    } else {
      t2 = $[26];
      t3 = $[27];
      t4 = $[28];
      t5 = $[29];
    }
    t6 = "text-base lg:text-lg text-[#303030] rich-text-content font-medium";
    t7 = activeTab === "description" ? <><div className="relative"><div className="max-h-32 overflow-hidden relative break-words whitespace-normal leading-relaxed text-[#5A5A5A]">{parse(formatContent(activeTabContent?.content || ""))}</div><div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent pointer-events-none" /></div><Dialog open={isModalOpen} onOpenChange={setIsModalOpen}><style>{"\n                      @media (max-width: 1024px) {\n                        .mobile-drawer-modal {\n                          top: auto !important;\n                          bottom: 0 !important;\n                          transform: translateX(-50%) translateY(0) !important;\n                          border-bottom-left-radius: 0 !important;\n                          border-bottom-right-radius: 0 !important;\n                          border-top-left-radius: 24px !important;\n                          border-top-right-radius: 24px !important;\n                          margin-bottom: 0 !important;\n                          width: 100vw !important;\n                          max-width: 100vw !important;\n                          animation: drawerSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;\n                        }\n                        @keyframes drawerSlideUp {\n                          from { transform: translateX(-50%) translateY(100%); }\n                          to { transform: translateX(-50%) translateY(0); }\n                        }\n                        /* Hide the exit animation of standard dialog to prevent jumps */\n                        .mobile-drawer-modal[data-state=\"closed\"] {\n                          animation: drawerSlideDown 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;\n                        }\n                        @keyframes drawerSlideDown {\n                          from { transform: translateX(-50%) translateY(0); }\n                          to { transform: translateX(-50%) translateY(100%); }\n                        }\n                      }\n                    "}</style><DialogTrigger asChild={true}><button className="mt-4 px-6 py-2.5 rounded-full bg-[#037A6A]/10 text-[#037A6A] font-semibold text-sm transition-all hover:bg-[#037A6A]/20 hover:scale-105 active:scale-95 flex items-center shadow-sm outline-none">Read more<svg className="w-4 h-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg></button></DialogTrigger><DialogContent className="mobile-drawer-modal max-w-2xl max-h-[85vh] overflow-y-auto rounded-2xl border-none shadow-2xl bg-white/95 backdrop-blur-xl p-6 sm:p-8"><DialogHeader className="mb-6 border-b border-gray-100 pb-4"><DialogTitle className="uppercase text-2xl font-bold tracking-tight text-[#037A6A]">Product Description</DialogTitle></DialogHeader><div className="mt-4 text-base lg:text-lg rich-text-content break-words whitespace-normal text-[#5A5A5A] leading-relaxed space-y-4 font-medium">{parse(formatContent(activeTabContent?.content || ""))}</div></DialogContent></Dialog></> : <div className="break-words whitespace-normal leading-relaxed text-[#5A5A5A]">{parse(formatContent(activeTabContent?.content || ""))}</div>;
    $[0] = activeTab;
    $[1] = isModalOpen;
    $[2] = tabs;
    $[3] = T0;
    $[4] = T1;
    $[5] = t1;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    T0 = $[3];
    T1 = $[4];
    t1 = $[5];
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t13;
  if ($[30] !== T0 || $[31] !== t1 || $[32] !== t2 || $[33] !== t3 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t7) {
    t13 = <T0 key={t1} initial={t2} animate={t3} exit={t4} transition={t5} className={t6}>{t7}</T0>;
    $[30] = T0;
    $[31] = t1;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== T1 || $[40] !== t13 || $[41] !== t8) {
    t14 = <T1 mode={t8}>{t13}</T1>;
    $[39] = T1;
    $[40] = t13;
    $[41] = t8;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t14 || $[44] !== t9) {
    t15 = <div className={t9}>{t14}</div>;
    $[43] = t14;
    $[44] = t9;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== t10 || $[47] !== t11 || $[48] !== t15) {
    t16 = <div className={t10}>{t11}{t15}</div>;
    $[46] = t10;
    $[47] = t11;
    $[48] = t15;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  let t17;
  if ($[50] !== t12 || $[51] !== t16) {
    t17 = <div className={t12}>{t16}</div>;
    $[50] = t12;
    $[51] = t16;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  return t17;
};
export default ProductTabs;
function _temp(content) {
  if (!content) {
    return "";
  }
  return content.replace(/<(p|div)([^>]*)>(?:\s|&nbsp;)*<\/\1>/gi, "<$1$2><br/></$1>").replace(/&nbsp;/g, " ");
}